'use client'

import type {
	OrganizationStatusEnum,
	UserOrganizationRoleEnum,
} from '@carbonara/postgres/src/schema'
import { type ReactNode, createContext, useContext } from 'react'

interface OrgContextProps {
	id: string
	name: string
	organization_number?: string | null
	status: OrganizationStatusEnum
	is_demo: boolean
	user_role?: UserOrganizationRoleEnum
}

const OrgContext = createContext<OrgContextProps | undefined>(undefined)

export const OrgProvider = ({
	org,
	children,
}: { children: ReactNode; org: OrgContextProps }) => (
	<OrgContext.Provider value={org}>{children}</OrgContext.Provider>
)

export const useOrg = (): OrgContextProps => {
	const context = useContext(OrgContext)
	if (context === undefined) {
		throw new Error('useOrg must be used within a OrgProvider')
	}
	return context
}
